var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logout_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.6,
    d: "M9.492 13.575a.83.83 0 0 0 1.175 0l2.991-2.992a.83.83 0 0 0 0-1.175l-2.991-2.991a.83.83 0 1 0-1.175 1.175l1.566 1.575H3.833A.836.836 0 0 0 3 10c0 .458.375.833.833.833h7.225L9.492 12.4a.84.84 0 0 0 0 1.175M16.333 2.5H4.667C3.742 2.5 3 3.25 3 4.167v2.5c0 .458.375.833.833.833a.836.836 0 0 0 .834-.833V5c0-.458.375-.833.833-.833h10c.458 0 .833.375.833.833v10a.836.836 0 0 1-.833.833h-10A.836.836 0 0 1 4.667 15v-1.667a.836.836 0 0 0-.834-.833.836.836 0 0 0-.833.833v2.5c0 .917.75 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V4.167c0-.917-.75-1.667-1.667-1.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logout_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h20v20H.5z"
  })))));
};
export default SvgLogout;